export enum UserRoles {
  MEMBER = "member",
  ADMIN = "admin",
  VISITEUR = "Visiteur",
  INVESTISSEUR = "Investisseur",
  MENTOR = "mentor",
  JEUNEINNOVATEUR = "jeuneInnovateur",
}
